/* ⭐claude 18.10.26 (V38) Maßsuche mit Toleranz ±15 mm – PMH Filter Service */
(function () {
  if (window.pmhMassInit) return; window.pmhMassInit = true;
  var TOL = 15, EXACT = 2, MAX = 12, KEY = 'pmhMasseV1';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function parse(q) {
    var m = String(q || '').match(/(\d{2,4})(?:[.,]\d+)?\s*(?:mm)?\s*(?:[x×X*\/]|\s)\s*(\d{2,4})(?:[.,]\d+)?/);
    return m ? [parseInt(m[1], 10), parseInt(m[2], 10)] : null;
  }
  var idx = null;
  function load() {
    if (idx) return idx;
    try { var c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (c && Date.now() - c.ts < 3600000) { idx = Promise.resolve(c.d); return idx; } } catch (e) {}
    idx = (async function () {
      var all = [];
      for (var pg = 1; pg <= 10; pg++) {
        var r = await fetch('/collections/all?view=pmh-masse&page=' + pg, { credentials: 'same-origin' });
        if (!r.ok) throw new Error('Index ' + r.status);
        var j = JSON.parse(await r.text());
        all = all.concat(j.p || []);
        if (!j.next) break;
      }
      var d = [];
      all.forEach(function (p) {
        var z = [], seen = {}, re = /(\d{2,4})\s*[x×X]\s*(\d{2,4})/g, m;
        while ((m = re.exec(p.s))) { var a = +m[1], b = +m[2], k = a + 'x' + b; if (a >= 50 && b >= 10 && !seen[k]) { seen[k] = 1; z.push([a, b]); } }
        if (z.length) d.push({ t: p.t, u: p.u, i: p.i, pr: p.pr, v: p.v, z: z });
      });
      try { sessionStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), d: d })); } catch (e) {}
      return d;
    })();
    idx.catch(function () { idx = null; });
    return idx;
  }
  function match(d, a, b) {
    var res = [];
    d.forEach(function (p) {
      var best = null;
      p.z.forEach(function (z) {
        [[z[0], z[1]], [z[1], z[0]]].forEach(function (o) {
          var da = Math.abs(o[0] - a), db = Math.abs(o[1] - b), dev = Math.max(da, db), sum = da + db;
          if (dev <= TOL && (!best || dev < best.dev || (dev === best.dev && sum < best.sum))) best = { dev: dev, sum: sum, z: z };
        });
      });
      if (best) res.push({ p: p, b: best });
    });
    res.sort(function (x, y) { return x.b.dev - y.b.dev || x.b.sum - y.b.sum || x.p.t.localeCompare(y.p.t); });
    return res;
  }
  function item(r) {
    var ok = r.b.dev <= EXACT, z = r.b.z[0] + ' × ' + r.b.z[1] + ' mm';
    return '<li><a class="pmh-ms__it" href="' + esc(r.p.u) + '">' +
      '<span class="pmh-ms__img">' + (r.p.i ? '<img src="' + esc(r.p.i) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span>' +
      '<span class="pmh-ms__b"><span class="pmh-ms__t">' + esc(r.p.t) + '</span>' +
      '<span class="pmh-ms__z' + (ok ? ' pmh-ms__z--ok' : '') + '">' + (ok ? 'Passt: ' : 'Ähnlich: ') + z + (ok ? '' : ' (± ' + r.b.dev + ' mm)') + '</span>' +
      (r.p.pr ? '<span class="pmh-ms__p">' + (r.p.v ? 'ab ' : '') + esc(r.p.pr) + '</span>' : '') +
      '</span></a></li>';
  }
  function show(out, q, a, b) {
    out.hidden = false;
    out.innerHTML = '<p class="pmh-ms__load">Filter mit ähnlichen Maßen werden gesucht …</p>';
    var allUrl = '/search?type=product&q=' + encodeURIComponent(q);
    load().then(function (d) {
      var res = match(d, a, b), head = 'Filter für ' + a + ' × ' + b + ' mm';
      if (!res.length) {
        out.innerHTML = '<p class="pmh-ms__h">' + head + ': kein Filter innerhalb von ± ' + TOL + ' mm gefunden</p>' +
          '<p class="pmh-ms__hint">Filtermatten schneiden wir auch nach Maß zu – oder schicken Sie uns die Gerätebezeichnung, wir helfen beim Finden.</p>' +
          '<div class="pmh-ms__more"><a href="/collections/filtermatten-meterware">Filtermatten nach Maß</a><a href="/pages/kontakt">Kontakt</a><a href="' + allUrl + '">Normale Suche</a></div>';
        return;
      }
      var nOk = res.filter(function (r) { return r.b.dev <= EXACT; }).length;
      var html = '<p class="pmh-ms__h">' + head + ': ' + res.length + (res.length === 1 ? ' Filter' : ' Filter') + (nOk ? ' (' + nOk + ' genau passend)' : ' mit ähnlichem Maß') + '</p>' +
        '<p class="pmh-ms__hint">Angezeigt werden Filter bis ± ' + TOL + ' mm Abweichung. Bitte vergleichen Sie das angegebene Maß mit Ihrem Originalfilter, bevor Sie bestellen.</p>' +
        '<ul class="pmh-ms__list">' + res.slice(0, MAX).map(item).join('') + '</ul>';
      html += '<div class="pmh-ms__more">' + (res.length > MAX ? '<button type="button" data-pmh-ms-all>Alle ' + res.length + ' anzeigen</button>' : '') + '<a href="/collections/filtermatten-meterware">Filtermatten nach Maß</a><a href="/pages/kontakt">Filter nicht dabei? Kontakt</a></div>';
      out.innerHTML = html;
      var btn = out.querySelector('[data-pmh-ms-all]');
      if (btn) btn.addEventListener('click', function () { out.querySelector('.pmh-ms__list').innerHTML = res.map(item).join(''); btn.remove(); });
    }).catch(function () {
      out.innerHTML = '<p class="pmh-ms__hint">Die Maßsuche ist gerade nicht verfügbar. <a href="' + allUrl + '">Zur normalen Suche</a></p>';
    });
  }
  function outFor(form) {
    var scope = form.closest('[data-pmh-mass-scope]') || form.parentElement;
    var out = scope.querySelector('[data-pmh-mass-out]');
    if (!out) { out = document.createElement('div'); out.className = 'pmh-ms'; out.setAttribute('data-pmh-mass-out', ''); form.after(out); }
    return out;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-pmh-mass]')) return;
    var inp = f.querySelector('input[name="q"]'), q = inp ? inp.value : '', ab = parse(q);
    if (!ab) return; // keine zwei Zahlen: normale Suche
    e.preventDefault();
    show(outFor(f), q, ab[0], ab[1]);
  });
  function auto() {
    document.querySelectorAll('[data-pmh-mass-out][data-q]').forEach(function (out) {
      var q = out.getAttribute('data-q'), ab = parse(q);
      if (ab && /^\s*\d{2,4}\D{1,6}\d{2,4}(\D{1,6}\d{1,3})?\s*(mm)?\s*$/i.test(q)) show(out, q, ab[0], ab[1]);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto); else auto();
})();
